/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import { useLocalStorage } from '@/hooks/common'
import useAppStore from '@/store/useAppStore'

export const useGetConnectRecommendations = () => {
  const axios = useContext(AxiosContext);
  const [ewUser] = useLocalStorage('ewUser', null);
  const { setRecommendations } = useAppStore();
  return useMutation({
    mutationKey: [ReactQueryKeys.CONNECTION_RECOMMENDS],
    mutationFn: async () => {
      const response = await axios.api.post('ajax/users', {
        requestType: "connectionRecommendations",
        connID: ewUser.userID,
        format: "json",
      })
      setRecommendations(response.data?.recommendedConnections || [])
      return response.data?.recommendedConnections || []
    },
  })
}
